import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import LoadingFallback from "./components/LoadingFallback";
import { AuthProvider } from "./context/AuthContext";

const Hero = lazy(() => import("./pages/Hero"));
const About = lazy(() => import("./pages/About"));
const PcbDesign = lazy(() => import("./pages/PcbDesign"));
const Fabrication = lazy(() => import("./pages/Fabrication"));
const Assembly = lazy(() => import("./pages/Assembly"));
const MechanicalDesign = lazy(() => import("./pages/MechanicalDesign"));
const Contact = lazy(() => import("./pages/Contact"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const Profile = lazy(() => import("./pages/Profile"));

function App() {
    return (
        <AuthProvider>
            <ScrollToTop /> 
            <Suspense fallback={<LoadingFallback />}>
                <Routes>
                    <Route path="/" element={<Hero />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/pcb-design" element={<PcbDesign />} />
                    <Route path="/fabrication" element={<Fabrication />} />
                    <Route path="/assembly" element={<Assembly />} />
                    <Route path="/mechanical-design" element={<MechanicalDesign />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                    <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
                    <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                </Routes>
            </Suspense>
        </AuthProvider>
    );
}

export default App;
